import { css } from 'styled-components';

import { generateStyleFromPattern } from '../../utilities/generate-style-from-pattern';

export const styleBase = css`
  html, body, #root {
    height: 100%;
  }

  body {
    font-family: Roboto, sans-serif;
    background-color: ${({ theme }) => theme.colorTokens.aliases.bodyBackground};
    color: ${({ theme }) => theme.colorTokens.aliases.textLight};
    ${ ({ theme }) => generateStyleFromPattern(theme.typographyPatterns, 'body') }
    display: flex;
    flex-direction: column;
  }
  a {
    color: ${({ theme }) => theme.colorTokens.aliases.link};
  }
`;
